import request from '@/libs/http/index'
// es-获得药械列表
export const getDrugDeviceCatalogkEsList = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/es-list`,
    params,
  })
}
// 获得药械分页
export const drugDeviceCatalogkEsPage = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/es-page`,
    params,
  })
}
// 获得药械统计
export const drugDeviceCatalogkEsSummary = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/es-summary`,
    params,
  })
}

// 获得药械详情
export const drugDeviceStockDetail = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/get`,
    params,
  })
}

// 创建药械
export const drugDeviceStockCreate = data => {
  return request.post({
    url: `/clinic/drug-device-catalog/create`,
    data,
  })
}
// 批量创建药械
export const drugDeviceStockBatchCreate = data => {
  return request.post({
    url: `/clinic/drug-device-catalog/batch-create`,
    data,
  })
}
// 批量校验药械
export const drugDeviceStockBatchCreateCheck = data => {
  return request.post({
    url: `/clinic/drug-device-catalog/batch-create-check`,
    data,
  })
}
// 批量创建药械-新
export const drugDeviceStockBatchCreateStock = data => {
  return request.post({
    url: `/clinic/drug-device-catalog/batch-create-catalog`,
    data,
  })
}
// 更新药械
export const drugDeviceStockUpdate = data => {
  return request.put({
    url: `/clinic/drug-device-stock/update`,
    data,
  })
}

// 获得药械类型列表
export const drugDeviceTypeList = params => {
  return request.get({
    url: `/clinic/drug-device-type/list`,
    params,
  })
}
// 获得药械产品预警数
export const drugDeviceGetEsWarnCount = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/getEsWarnCount`,
    params,
  })
}
// 获取后台维护药品目录
export const getDrugCataloguePage = params => {
  return request.get({
    url: `/clinic/drug-catalogue/page`,
    params,
  })
}
// es-获取后台维护药品目录列表
export const getDrugCatalogueEsList = params => {
  return request.get({
    url: `/clinic/drug-catalogue/es-list`,
    params,
  })
}
// es-获取后台维护药品目录列表
export const getDrugCatalogueEsPage = params => {
  return request.get({
    url: `/clinic/drug-catalogue/es-page`,
    params,
  })
}

// 导出药械库存列表
export const drugDeviceStockEsPageExport = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/page-export`,
    params,
  })
}
// 导出批次药品列表
export const drugEsPageExport = params => {
  return request.get({
    url: `/clinic/drug-device-stock/page-export`,
    params,
  })
}
// 批次-----------------------------------------------
// 药品目录
export const drugDeviceCatalogCreate = data => {
  return request.post({
    url: `/clinic/drug-device-catalog/create`,
    data,
  })
}
// 更新药品目录
export const drugDeviceCatalogUpdate = data => {
  return request.put({
    url: `/clinic/drug-device-catalog/update`,
    data,
  })
}
// 获得药品目录详情
export const drugDeviceCatalogDetail = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/get`,
    params,
  })
}

// ids批量查询药品目录
export const getDrugDeviceCatalogList = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/get-list`,
    params: {
      ...params,
      ids: Array.isArray(params?.ids) ? params.ids.join(',') : params?.ids,
    },
  })
}

// 名称批量查询药品目录
export const getDrugDeviceCatalogGetList = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/get-list-name`,
    params,
  })
}

// 药品目录下的药品分页列表
export const getDrugStockPage = params => {
  return request.get({
    url: `/clinic/drug-device-stock/get-drug-stock-page`,
    params,
  })
}
// 药品目录下的药品分页列表
export const getDrugStockList = params => {
  return request.get({
    url: `/clinic/drug-device-stock/get-drug-stock-list`,
    params,
  })
}
// 批量调价
export const drugDeviceCatalogBatchUpdatePrice = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/batch-price`,
    params,
  })
}

// 预览药品批量调价结果
export const drugPriceAdjustRecordPreview = data => {
  return request.post({
    url: `/clinic/drug-price-adjust-record/preview`,
    data,
  })
}

// 执行药品批量调价并保存记录
export const drugPriceAdjustRecordAdjust = data => {
  return request.post({
    url: `/clinic/drug-price-adjust-record/adjust`,
    data,
  })
}

// 获得药品批量调价记录分页
export const drugPriceAdjustRecordPage = params => {
  return request.get({
    url: `/clinic/drug-price-adjust-record/page`,
    params,
  })
}

// 获得药品批量调价记录
export const drugPriceAdjustRecordDetail = params => {
  return request.get({
    url: `/clinic/drug-price-adjust-record/get`,
    params,
  })
}

// 获得药品批量调价记录明细列表
export const drugPriceAdjustRecordItemList = params => {
  return request.get({
    url: `/clinic/drug-price-adjust-record/item-list`,
    params,
  })
}

// 根据商品类型和最近供应商查询批量调价药品目录
export const drugPriceAdjustRecordCatalogList = params => {
  return request.get({
    url: `/clinic/drug-price-adjust-record/catalog-list`,
    params,
  })
}

// 获得药品库存变动结果分页
export const getDrugStockRecordPage = params => {
  return request.get({
    url: `/clinic/drug-stock-record/page`,
    params,
  })
}

// es-获得药械列表
export const getDrugDeviceCatalogkEsSameNameList = params => {
  return request.get({
    url: `/clinic/drug-device-catalog/es-same-name-list`,
    params,
  })
}

// 获得单品预警设置
export const getDrugWarningSetting = params => {
  return request.get({
    url: `/clinic/drug-warning-setting/get`,
    params,
  })
}

// 保存单品预警设置
export const saveDrugWarningSetting = data => {
  return request.post({
    url: `/clinic/drug-warning-setting/save`,
    data,
  })
}
